import React, { useMemo, useState } from "react";
import { useGame, usePlayer, usePlayers } from "@empirica/core/player/classic/react";
import { Button } from "../components/Button";
import { getCounterpartCopy } from "../payoffFrame";
import { Stage2ContributionQuestion } from "../stage2/Stage2ContributionQuestion";
import {
  CONTRIBUTION_AFTER_CHATBOT,
  shouldAskContribution,
} from "../../../shared/contributionAssessment.js";

export function PostChatbotPetQuestion() {
  const game = useGame();
  const player = usePlayer();
  const players = usePlayers();
  const counterpart = getCounterpartCopy(game.get("design"));

  const catsOnRight =
    player.get("prePetCatsOnRight") ??
    player.stage.get("postPetCatsOnRight") ??
    true;
  const leftLabel = catsOnRight ? "Dogs" : "Cats";
  const rightLabel = catsOnRight ? "Cats" : "Dogs";

  const [sliderValue, setSliderValue] = useState(
    player.stage.get("postPetSliderValue") ?? 50
  );
  const [sliderTouched, setSliderTouched] = useState(
    player.stage.get("postPetSliderValue") != null
  );

  const allSubmitted = useMemo(
    () => players.every((p) => p.stage.get("submit")),
    [players]
  );

  function handleSliderChange(e) {
    const val = Number(e.target.value);
    setSliderValue(val);
    setSliderTouched(true);
    player.stage.set("postPetSliderValue", val);
    player.stage.set("postPetCatsOnRight", catsOnRight);
    player.stage.set("postPetCatsPreference", catsOnRight ? val : 100 - val);
  }

  function handleContinue() {
    if (shouldAskContribution(player, CONTRIBUTION_AFTER_CHATBOT)) {
      player.stage.set("stage2ContributionQuestionShown", true);
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      return;
    }
    player.stage.set("submit", true);
  }

  if (player.stage.get("stage2ContributionQuestionShown")) {
    return (
      <Stage2ContributionQuestion
        timing={CONTRIBUTION_AFTER_CHATBOT}
        next={() => player.stage.set("submit", true)}
        disabled={player.stage.get("submit") === true}
      />
    );
  }

  return (
    <div className="py-10 max-w-4xl mx-auto px-8 space-y-8">
      <div className="rounded-md border border-gray-200 p-5 space-y-3 text-2xl text-gray-700">
        <p className="font-medium text-gray-900">Which make better pets: {leftLabel.toLowerCase()} or {rightLabel.toLowerCase()}?</p>
        <div className="flex items-center space-x-3">
          <span className="w-12 text-right font-medium">{leftLabel}</span>
          <input
            type="range"
            min={0}
            max={100}
            value={sliderValue}
            onChange={handleSliderChange}
            className="flex-1 neutral-slider"
          />
          <span className="w-12 font-medium">{rightLabel}</span>
        </div>
      </div>

      <div className="flex items-center space-x-4">
        <Button handleClick={handleContinue} autoFocus disabled={!sliderTouched || player.stage.get("submit")}>
          <p>Continue</p>
        </Button>
        {player.stage.get("submit") && !allSubmitted ? (
          <span className="text-sm text-gray-500">
            Waiting for {counterpart.term}…
          </span>
        ) : null}
      </div>
    </div>
  );
}
